export default "__VITE_ASSET__W7ypqD8Q__"